module.exports = __webpack_public_path__ + "static/img/icon_float_correction.f76ccab5.png";